import React from 'react';
import { Gavel } from '@mui/icons-material';
import { StyledLink } from '../Components';
import { useQuery } from '@apollo/client';
import { Typography, Grid2 as Grid, Divider, CircularProgress } from '@mui/material';
import { GET_UNHANDLED_REGULATION_CHANGES } from './dashboard.graphql';
import { StyledPaper } from '../theme';

export function RegulationChanges() {
  const { data, loading } = useQuery(GET_UNHANDLED_REGULATION_CHANGES);
  return (
    <StyledPaper>
      <Typography variant="h5">Utdaterte paragrafer</Typography>
      <Grid container>
        <Grid size={{ xs: 1 }} style={{ paddingTop: 10 }}>
          <Gavel fontSize="large" sx={{ color: (theme) => theme.palette.primary.main }} />
        </Grid>
        <Grid size={{ xs: 11 }}>
          <Typography align="right" variant="h4" color="primary">
            {loading && <CircularProgress size={40} />}
            {data?.paragraphChanges?.length}
          </Typography>
        </Grid>
      </Grid>
      <Divider />
      <StyledLink to="/paragraph">Gå til TEK</StyledLink>
    </StyledPaper>
  );
}
